import { start } from '@rails/activestorage'

start()
